import { apiClient } from './client'
import type { ProfileResponse, UpdateProfileInput, ChangePasswordInput } from '@/types/profile'

export const profileApi = {
  /**
   * Get current user's profile
   */
  getProfile: async (): Promise<ProfileResponse> => {
    const response = await apiClient.get<ProfileResponse>('/profile')
    return response.data
  },

  /**
   * Update current user's profile (first name, last name)
   */
  updateProfile: async (data: UpdateProfileInput): Promise<ProfileResponse> => {
    const response = await apiClient.patch<ProfileResponse>('/profile', data)
    return response.data
  },

  /**
   * Change current user's password
   */
  changePassword: async (data: ChangePasswordInput): Promise<ProfileResponse> => {
    const response = await apiClient.post<ProfileResponse>('/profile/change-password', data)
    return response.data
  },

  /**
   * Setup TOTP (Authenticator App) MFA
   * Returns secret code and QR code URL
   */
  setupTOTP: async (): Promise<ProfileResponse> => {
    const response = await apiClient.post<ProfileResponse>('/profile/mfa/totp/setup')
    return response.data
  },

  /**
   * Verify TOTP code and enable TOTP MFA
   */
  verifyTOTP: async (totpCode: string): Promise<ProfileResponse> => {
    const response = await apiClient.post<ProfileResponse>('/profile/mfa/totp/verify', { totpCode })
    return response.data
  },

  /**
   * Enable SMS MFA
   */
  enableSMSMFA: async (): Promise<ProfileResponse> => {
    const response = await apiClient.post<ProfileResponse>('/profile/mfa/sms/enable')
    return response.data
  },

  /**
   * Disable all MFA methods
   */
  disableMFA: async (): Promise<ProfileResponse> => {
    const response = await apiClient.post<ProfileResponse>('/profile/mfa/disable')
    return response.data
  },
}
